import * as React from 'react';

const NotFound: React.SFC<{}> = (props) => {
    return <div>Page not found</div>;
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/common/NotFound.tsx